
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host {
  display: block;
}

outline-container {
  display: grid;
  height: 100%;
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

:host([gap-size='large']) outline-container, :host([gap-size-sm='large']) outline-container, :host([gap-size-md='large']) outline-container, :host([gap-size-lg='large']) outline-container, :host([gap-size-xl='large']) outline-container, :host([gap-size-xxl='large']) outline-container, :host([gap-size-xxxl='large']) outline-container {
  row-gap: var(--spacing-16);
  column-gap: 0;
}

:host([gap-size='medium']) outline-container, :host([gap-size-sm='medium']) outline-container, :host([gap-size-md='medium']) outline-container, :host([gap-size-lg='medium']) outline-container, :host([gap-size-xl='medium']) outline-container, :host([gap-size-xxl='medium']) outline-container, :host([gap-size-xxxl='medium']) outline-container {
  row-gap: var(--spacing-10);
  column-gap: 0;
}

:host([gap-size='small']) outline-container, :host([gap-size-sm='small']) outline-container, :host([gap-size-md='small']) outline-container, :host([gap-size-lg='small']) outline-container, :host([gap-size-xl='small']) outline-container, :host([gap-size-xxl='small']) outline-container, :host([gap-size-xxxl='small']) outline-container {
  row-gap: var(--spacing-04);
  column-gap: 0;
}

:host([gap-size='none']) outline-container {
  gap: 0;
}

@media (min-width: 640px){
  :host([gap-size='large']) outline-container {
    row-gap: var(--spacing-16);
  }
  :host([gap-size='large']) outline-container {
    column-gap: var(--spacing-16);
  }

  :host([gap-size='medium']) outline-container {
    row-gap: var(--spacing-10);
  }

  :host([gap-size='medium']) outline-container {
    column-gap: var(--spacing-10);
  }

  :host([gap-size='small']) outline-container {
    row-gap: var(--spacing-04);
  }

  :host([gap-size='small']) outline-container {
    column-gap: var(--spacing-04);
  }
  :host([is-auto-fitted='true']) outline-container{
    grid-template-columns:repeat(auto-fit, minmax(0, 1fr));
  }
  :host([gap-size-sm='large']) outline-container {
    row-gap: var(--spacing-16);
  }
  :host([gap-size-sm='large']) outline-container {
    column-gap: var(--spacing-16);
  }
  :host([gap-size-sm='medium']) outline-container {
    row-gap: var(--spacing-10);
  }
  :host([gap-size-sm='medium']) outline-container {
    column-gap: var(--spacing-10);
  }
  :host([gap-size-sm='small']) outline-container {
    row-gap: var(--spacing-04);
  }
  :host([gap-size-sm='small']) outline-container {
    column-gap: var(--spacing-04);
  }
  :host([gap-size-sm='none']) outline-container {
    gap: 0;
  }
}

@media (min-width: 768px){
  :host([gap-size-md='large']) outline-container {
    row-gap: var(--spacing-16);
  }
  :host([gap-size-md='large']) outline-container {
    column-gap: var(--spacing-16);
  }
  :host([gap-size-md='medium']) outline-container {
    row-gap: var(--spacing-10);
  }
  :host([gap-size-md='medium']) outline-container {
    column-gap: var(--spacing-10);
  }
  :host([gap-size-md='small']) outline-container {
    row-gap: var(--spacing-04);
  }
  :host([gap-size-md='small']) outline-container {
    column-gap: var(--spacing-04);
  }
  :host([gap-size-md='none']) outline-container {
    gap: 0;
  }
}

@media (min-width: 1024px){
  :host([gap-size-lg='large']) outline-container {
    row-gap: var(--spacing-16);
  }
  :host([gap-size-lg='large']) outline-container {
    column-gap: var(--spacing-16);
  }
  :host([gap-size-lg='medium']) outline-container {
    row-gap: var(--spacing-10);
  }
  :host([gap-size-lg='medium']) outline-container {
    column-gap: var(--spacing-10);
  }
  :host([gap-size-lg='small']) outline-container {
    row-gap: var(--spacing-04);
  }
  :host([gap-size-lg='small']) outline-container {
    column-gap: var(--spacing-04);
  }
  :host([gap-size-lg='none']) outline-container {
    gap: 0;
  }
}

@media (min-width: 1380px){
  :host([gap-size-xl='large']) outline-container {
    row-gap: var(--spacing-16);
  }
  :host([gap-size-xl='large']) outline-container {
    column-gap: var(--spacing-16);
  }
  :host([gap-size-xl='medium']) outline-container {
    row-gap: var(--spacing-10);
  }
  :host([gap-size-xl='medium']) outline-container {
    column-gap: var(--spacing-10);
  }
  :host([gap-size-xl='small']) outline-container {
    row-gap: var(--spacing-04);
  }
  :host([gap-size-xl='small']) outline-container {
    column-gap: var(--spacing-04);
  }
  :host([gap-size-xl='none']) outline-container {
    gap: 0;
  }
}

@media (min-width: 1920px){
  :host([gap-size-xxl='large']) outline-container {
    row-gap: var(--spacing-16);
  }
  :host([gap-size-xxl='large']) outline-container {
    column-gap: var(--spacing-16);
  }
  :host([gap-size-xxl='medium']) outline-container {
    row-gap: var(--spacing-10);
  }
  :host([gap-size-xxl='medium']) outline-container {
    column-gap: var(--spacing-10);
  }
  :host([gap-size-xxl='small']) outline-container {
    row-gap: var(--spacing-04);
  }
  :host([gap-size-xxl='small']) outline-container {
    column-gap: var(--spacing-04);
  }
  :host([gap-size-xxl='none']) outline-container {
    gap: 0;
  }
}

@media (min-width: 2180px){
  :host([gap-size-xxl='large']) outline-container {
    row-gap: var(--spacing-16);
  }
  :host([gap-size-xxl='large']) outline-container {
    column-gap: var(--spacing-16);
  }
  :host([gap-size-xxl='medium']) outline-container {
    row-gap: var(--spacing-10);
  }
  :host([gap-size-xxl='medium']) outline-container {
    column-gap: var(--spacing-10);
  }
  :host([gap-size-xxl='small']) outline-container {
    row-gap: var(--spacing-04);
  }
  :host([gap-size-xxl='small']) outline-container {
    column-gap: var(--spacing-04);
  }
  :host([gap-size-xxl='none']) outline-container {
    gap: 0;
  }
}
`;